export default "__VITE_ASSET__72cc7fa6__"